import { createTheme } from '@mui/material';

/**
 * Typography Constants — Heal at India Brand Theme
 * Matching the website retreat dashboard & AGENTS.md rules:
 * - FONT_BASE: 'Inter', 'SF Pro Display', sans-serif (clean, lightweight neo-grotesque)
 */
export const FONT_BASE = "'Inter', 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";

const theme = createTheme({
    palette: {
        success: {
            main: "#4BCE97",
            background: "#EDFAF5",
        },
        primary: {
            main: "#FFBD65",
            background: "#FBFBFB",
            border: "#C3C3C3"
        },
        secondary: {
            main: "#BCBCBC",
            sidemenutext: "#000000",
            background: "#FFFFFF",
            textColor: "#000000"
        },
        error: {
            main: "#FF0000",
        },
        default: {
            main: "#445371",
            background: "#44537126",
        },
    },
    typography: {
        fontFamily: FONT_BASE,
        fontSize: 14,
        fontWeightBold: 600,
        h1: {
            fontFamily: FONT_BASE,
            fontWeight: 300,
            fontSize: "80px",
        },
        h2: {
            fontFamily: FONT_BASE,
            fontWeight: 300,
            fontSize: "48px",
        },
        h3: {
            fontFamily: FONT_BASE,
            fontWeight: 500,
            fontSize: "22px",
        },
        h4: {
            fontFamily: FONT_BASE,
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: "23.12px",
            letterSpacing: "0.00735em",
        },
        h5: {
            fontFamily: FONT_BASE,
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "26.67px",
        },
        h6: {
            fontFamily: FONT_BASE,
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "25.6px",
        },
        tableheading: {
            fontFamily: FONT_BASE,
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "25.6px",
        },
        body1: {
            fontFamily: FONT_BASE,
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: 1.3,
            letterSpacing: "0.00938em",
        },
        body2: {
            fontFamily: FONT_BASE,
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "18px",
            letterSpacing: "0.0071em",
            color: "#000000",
        },
        button: {
            fontFamily: FONT_BASE,
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "24.5px",
            letterSpacing: "0.02857em",
            textTransform: "none",
        },
        caption: {
            fontFamily: FONT_BASE,
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "19.92px",
            letterSpacing: "0.03333em",
        },
        overline: {
            fontFamily: FONT_BASE,
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "21.33px",
            letterSpacing: "0.08333em",
            textTransform: "uppercase",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    boxShadow: "none",
                    textTransform: "none",
                    fontFamily: FONT_BASE,
                },
                contained: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
                outlined: {
                    boxShadow: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    borderRadius: "8px",
                    "& .MuiOutlinedInput-root": {
                        borderColor: "primary.border",
                        "& fieldset": {
                            borderColor: "primary.border",
                        },
                        "&:hover fieldset": {
                            borderColor: "primary.border",
                        },
                        "&.Mui-focused fieldset": {
                            borderColor: "primary.border",
                        },
                    },
                    "& .MuiInputBase-input": {
                        fontSize: "14px",
                        fontFamily: FONT_BASE,
                        color: "primary.main",
                    },
                },
            },
        },
    },
});

export default theme;
